export enum DesignSettingsChangesActions {
  REMOVED = 'Removed',
  ADDED = 'Added',
  CHANGED = 'Changed',
  SET_AS_DEFAULT = 'Set as Default',
  VIEWED = 'Viewed',
  DUPLICATE = 'Duplicate',
  USED = 'Used',
  SAVED_SETTINGS = 'Saved Settings',
}

export enum DesignSettingsChangesSections {
  INTERACTIVE_CTAS = 'Interactive CTAs',
  THUMBNAILS = 'Thumbnails',
  CTA_SETS = 'CTA Sets',
}
